export enum RoleEnum {
  LB_API = 'LB_API',
  LB_SALE = 'LB_SALE',
  LB_TECH = 'LB_TECH',
  LB_DISTRIBUTOR = 'LB_DISTRIBUTOR',
  FRANCHISE_OWNER = 'FRANCHISE_OWNER',
  STORE_OWNER = 'STORE_OWNER',
  CUSTOMER = 'CUSTOMER',
}

interface BasePermissionDTO {
  role: RoleEnum;
}

interface ManagedFranchiseDAO {
  userId: string;
  franchiseId: string;
}

interface ManagedStoreDAO {
  storeId: string;
}

interface StoreOwnerPermissionDTO extends BasePermissionDTO {
  role: RoleEnum.STORE_OWNER;
  franchiseId: string;
  managedStores: ManagedStoreDAO[];
}

interface FranchiseOwnerPermissionDTO extends BasePermissionDTO {
  role: RoleEnum.FRANCHISE_OWNER;
  franchiseId: string;
}

interface DistributorPermissionDTO extends BasePermissionDTO {
  role: RoleEnum.LB_DISTRIBUTOR;
  managedFranchises: ManagedFranchiseDAO[];
}

export type PermissionDTO =
  | StoreOwnerPermissionDTO
  | FranchiseOwnerPermissionDTO
  | DistributorPermissionDTO
  | BasePermissionDTO;
/**
 * Authorization Roles
 */

export enum SpecialRolesEnum {
  REGISTERED = 'REGISTERED',
  NO_STORES = 'NO_STORES',
  RESTRICTED_STORE_OWNER = 'RESTRICTED_STORE_OWNER',
}

export type UserRolesType = RoleEnum | SpecialRolesEnum;
export const UserRolesType = { ...RoleEnum, ...SpecialRolesEnum };

export const isRoleEnum = (value: UserRolesType): value is RoleEnum => {
  return value in RoleEnum;
};

// pageAccess
const authRoles = {
  admin: [RoleEnum.LB_SALE, RoleEnum.LB_TECH, RoleEnum.LB_DISTRIBUTOR],
  // The merchant home settings and videos: LittleBill staff, not distributors.
  homeAdmin: [RoleEnum.LB_SALE, RoleEnum.LB_TECH],
  fullAccess: [RoleEnum.FRANCHISE_OWNER],
  registered: [SpecialRolesEnum.REGISTERED],
  noStores: [SpecialRolesEnum.RESTRICTED_STORE_OWNER],
  owner: [RoleEnum.FRANCHISE_OWNER, RoleEnum.STORE_OWNER],
  // The brand picker also admits the store-owner-with-no-stores pseudo-role: that
  // describes the brand they are currently on, and it must not stop them leaving it.
  brandPicker: [RoleEnum.FRANCHISE_OWNER, RoleEnum.STORE_OWNER, SpecialRolesEnum.RESTRICTED_STORE_OWNER],
  onlyGuest: [],
};

export default authRoles;
